import React, { FC, useMemo } from 'react';
import { Box } from '@mui/material';
import { ResultsTable } from './ResultsTable';
import { parseBlocks } from '../../utils/parseBlocks';

type PursuitTableProps = {
    values: string[][];
};

export const PursuitTable: FC<PursuitTableProps> = ({ values }) => {

    const blocks = useMemo(() => {
        if (!values || values.length === 0) return [];

        const result: { title: string; data: string[][] }[] = [];
        let currentBlock: { title: string; data: string[][] } | null = null;
        let isFinals = false;

        // 1. Zjistíme, jestli se jedná o Finále pomocí klasické smyčky
        for (const row of values) {
            if (row.join(' ').toLowerCase().includes('final for')) {
                isFinals = true;
                break; // Můžeme rovnou ukončit hledání, ušetříme výkon
            }
        }

        if (!isFinals) return [];

        // 2. Parsování Finále pomocí for...of smyčky (Řeší TypeScript chybu 'never')
        for (const row of values) {
            const rowStr = row.join(' ').toLowerCase();

            if (rowStr.includes('final for')) {
                if (currentBlock && currentBlock.data.length > 0) {
                    result.push(currentBlock);
                }

                const textCells = row.filter(c => c && String(c).trim() !== '');
                const titleMatches = textCells.filter(c => String(c).toLowerCase().includes('final for'));
                const titleCell = titleMatches.length > 0 ? titleMatches[titleMatches.length - 1] : textCells[textCells.length - 1];

                currentBlock = { title: String(titleCell).trim(), data: [] };
            }
            else if (currentBlock) {
                if (row.some(c => c && String(c).trim() !== '')) {
                    currentBlock.data.push(row);
                }
            }
        }

        // Tady už TypeScript přesně ví, co currentBlock je
        if (currentBlock && currentBlock.data.length > 0) {
            result.push(currentBlock);
        }

        return result;
    }, [values]);

    // =========================================================
    // 3. RENDER - KVALIFIKACE
    // =========================================================
    if (blocks.length === 0) {
        const parsed = parseBlocks(values);
        
        return (
            <Box>
                {parsed?.map((block, index) => {
                    if (block.data.length === 1) return null;
                    return <ResultsTable key={index} values={block.data} title={block.tableTitle} />;
                })}
            </Box>
        );
    }

    // =========================================================
    // 4. RENDER - FINÁLE
    // =========================================================
    return (
        <Box>
            {blocks.map((block, idx) => (
                <Box key={idx} sx={{ mb: 2 }}> 
                    <ResultsTable
                        values={block.data}
                        title={block.title}
                    />
                </Box>
            ))}
        </Box>
    );
};